// src/composables/useStaffHelpers.js

// Only returns '—' for truly empty values, so "0", "11234566" or "false" always display.
export const displayValue = (val) => {
  if (val === null || val === undefined || val === '') return '—'
  return val
}

export const getInitials = (first, last) => {
  const f = first ? first.charAt(0).toUpperCase() : ''
  const l = last ? last.charAt(0).toUpperCase() : ''
  return (f + l) || '??'
}

export const formatDate = (dateString) => {
  if (!dateString) return '—'
  try {
    return new Date(dateString).toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  } catch {
    return '—'
  }
}

export const getStatusClass = (status) => {
  const s = (status || '').toLowerCase()
  if (s === 'active' || s === 'hired') return 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300'
  if (s === 'on leave' || s === 'pending') return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300'
  if (s === 'inactive' || s === 'terminated') return 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300'
  return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
}

export const getFullFileUrl = (filePath) => {
  if (!filePath) return '#'
  if (filePath.startsWith('http://') || filePath.startsWith('https://')) return filePath
  const cleanPath = filePath.replace(/^\/+/, '')
//   const backendURL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/'
  const backendURL = import.meta.env.VITE_API_URL || 'https://ecole-ronsard.online/api/'

  return `${backendURL}${cleanPath}`
}

export const formatFileSize = (bytes) => {
  if (!bytes) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
}